module.exports = __webpack_public_path__ + "media/images/logo_new-58cfb555f618cb89f5ba7b9c623694a0.svg";